/**
 * @generated SignedSource<<5416ed82bae070edf578e1c8fdc6677a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCardFragment$data = {
  readonly host: {
    readonly " $fragmentSpreads": FragmentRefs<"ActivityCardHostFragment">;
  };
  readonly id: string;
  readonly shortDescription: string;
  readonly slug: string;
  readonly thumbnail: any | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "EventCardFragment";
};
export type EventCardFragment$key = {
  readonly " $data"?: EventCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActivityCardHostFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "153d159baf16135c17b147c146d70950";

export default node;
